import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import "core-js/modules/es.array.sort.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { isFalsyOrWhitespace } from '../../../base/common/strings.js';
import { createDecorator } from '../../instantiation/common/instantiation.js';
import { isMacintosh, isLinux, isWindows, isWeb } from '../../../base/common/platform.js';
var STATIC_VALUES = new Map();
STATIC_VALUES.set('false', false);
STATIC_VALUES.set('true', true);
STATIC_VALUES.set('isMac', isMacintosh);
STATIC_VALUES.set('isLinux', isLinux);
STATIC_VALUES.set('isWindows', isWindows);
STATIC_VALUES.set('isWeb', isWeb);
STATIC_VALUES.set('isMacNative', isMacintosh && !isWeb);
var hasOwnProperty = Object.prototype.hasOwnProperty;
export var ContextKeyExpr = /*#__PURE__*/function () {
  function ContextKeyExpr() {
    _classCallCheck(this, ContextKeyExpr);
  }

  _createClass(ContextKeyExpr, null, [{
    key: "has",
    value: function has(key) {
      return ContextKeyDefinedExpr.create(key);
    }
  }, {
    key: "equals",
    value: function equals(key, value) {
      return ContextKeyEqualsExpr.create(key, value);
    }
  }, {
    key: "regex",
    value: function regex(key, value) {
      return ContextKeyRegexExpr.create(key, value);
    }
  }, {
    key: "not",
    value: function not(key) {
      return ContextKeyNotExpr.create(key);
    }
  }, {
    key: "and",
    value: function and() {
      for (var _len = arguments.length, expr = new Array(_len), _key = 0; _key < _len; _key++) {
        expr[_key] = arguments[_key];
      }

      return ContextKeyAndExpr.create(expr);
    }
  }, {
    key: "or",
    value: function or() {
      for (var _len2 = arguments.length, expr = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        expr[_key2] = arguments[_key2];
      }

      return ContextKeyOrExpr.create(expr);
    }
  }, {
    key: "deserialize",
    value: function deserialize(serialized) {
      var strict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!serialized) {
        return undefined;
      }

      return this._deserializeOrExpression(serialized, strict);
    }
  }, {
    key: "_deserializeOrExpression",
    value: function _deserializeOrExpression(serialized, strict) {
      var _this = this;

      var pieces = serialized.split('||');
      return ContextKeyOrExpr.create(pieces.map(function (p) {
        return _this._deserializeAndExpression(p, strict);
      }));
    }
  }, {
    key: "_deserializeAndExpression",
    value: function _deserializeAndExpression(serialized, strict) {
      var _this2 = this;

      var pieces = serialized.split('&&');
      return ContextKeyAndExpr.create(pieces.map(function (p) {
        return _this2._deserializeOne(p, strict);
      }));
    }
  }, {
    key: "_deserializeOne",
    value: function _deserializeOne(serializedOne, strict) {
      serializedOne = serializedOne.trim();

      if (serializedOne.indexOf('!=') >= 0) {
        var pieces = serializedOne.split('!=');
        return ContextKeyNotEqualsExpr.create(pieces[0].trim(), this._deserializeValue(pieces[1], strict));
      }

      if (serializedOne.indexOf('==') >= 0) {
        var _pieces = serializedOne.split('==');

        return ContextKeyEqualsExpr.create(_pieces[0].trim(), this._deserializeValue(_pieces[1], strict));
      }

      if (serializedOne.indexOf('=~') >= 0) {
        var _pieces2 = serializedOne.split('=~');

        return ContextKeyRegexExpr.create(_pieces2[0].trim(), this._deserializeRegexValue(_pieces2[1], strict));
      }

      if (serializedOne.indexOf(' in ') >= 0) {
        var _pieces3 = serializedOne.split(' in ');

        return ContextKeyInExpr.create(_pieces3[0].trim(), _pieces3[1].trim());
      }

      if (/^\!\s*/.test(serializedOne)) {
        return ContextKeyNotExpr.create(serializedOne.substr(1).trim());
      }

      return ContextKeyDefinedExpr.create(serializedOne);
    }
  }, {
    key: "_deserializeValue",
    value: function _deserializeValue(serializedValue, strict) {
      serializedValue = serializedValue.trim();

      if (serializedValue === 'true') {
        return true;
      }

      if (serializedValue === 'false') {
        return false;
      }

      var m = /^'([^']*)'$/.exec(serializedValue);

      if (m) {
        return m[1].trim();
      }

      return serializedValue;
    }
  }, {
    key: "_deserializeRegexValue",
    value: function _deserializeRegexValue(serializedValue, strict) {
      if (isFalsyOrWhitespace(serializedValue)) {
        if (strict) {
          throw new Error('missing regexp-value for =~-expression');
        } else {
          console.warn('missing regexp-value for =~-expression');
        }

        return null;
      }

      var start = serializedValue.indexOf('/');
      var end = serializedValue.lastIndexOf('/');

      if (start === end || start < 0
      /* || to < 0 */
      ) {
        if (strict) {
          throw new Error("bad regexp-value '".concat(serializedValue, "', missing /-enclosure"));
        } else {
          console.warn("bad regexp-value '".concat(serializedValue, "', missing /-enclosure"));
        }

        return null;
      }

      var value = serializedValue.slice(start + 1, end);
      var caseIgnoreFlag = serializedValue[end + 1] === 'i' ? 'i' : '';

      try {
        return new RegExp(value, caseIgnoreFlag);
      } catch (e) {
        if (strict) {
          throw new Error("bad regexp-value '".concat(serializedValue, "', parse error: ").concat(e));
        } else {
          console.warn("bad regexp-value '".concat(serializedValue, "', parse error: ").concat(e));
        }

        return null;
      }
    }
  }]);

  return ContextKeyExpr;
}();

function _cmp(a, b) {
  return a.cmp(b);
}

export var ContextKeyFalseExpr = /*#__PURE__*/function () {
  function ContextKeyFalseExpr() {
    _classCallCheck(this, ContextKeyFalseExpr);

    this.type = 0
    /* False */
    ;
  }

  _createClass(ContextKeyFalseExpr, [{
    key: "cmp",
    value: function cmp(other) {
      return this.type - other.type;
    }
  }, {
    key: "equals",
    value: function equals(other) {
      return other.type === this.type;
    }
  }, {
    key: "evaluate",
    value: function evaluate(context) {
      return false;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return 'false';
    }
  }, {
    key: "keys",
    value: function keys() {
      return [];
    }
  }, {
    key: "negate",
    value: function negate() {
      return ContextKeyTrueExpr.INSTANCE;
    }
  }]);

  return ContextKeyFalseExpr;
}();
ContextKeyFalseExpr.INSTANCE = new ContextKeyFalseExpr();
export var ContextKeyTrueExpr = /*#__PURE__*/function () {
  function ContextKeyTrueExpr() {
    _classCallCheck(this, ContextKeyTrueExpr);

    this.type = 1
    /* True */
    ;
  }

  _createClass(ContextKeyTrueExpr, [{
    key: "cmp",
    value: function cmp(other) {
      return this.type - other.type;
    }
  }, {
    key: "equals",
    value: function equals(other) {
      return other.type === this.type;
    }
  }, {
    key: "evaluate",
    value: function evaluate(context) {
      return true;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return 'true';
    }
  }, {
    key: "keys",
    value: function keys() {
      return [];
    }
  }, {
    key: "negate",
    value: function negate() {
      return ContextKeyFalseExpr.INSTANCE;
    }
  }]);

  return ContextKeyTrueExpr;
}();
ContextKeyTrueExpr.INSTANCE = new ContextKeyTrueExpr();
export var ContextKeyDefinedExpr = /*#__PURE__*/function () {
  function ContextKeyDefinedExpr(key) {
    _classCallCheck(this, ContextKeyDefinedExpr);

    this.key = key;
    this.type = 2
    /* Defined */
    ;
  }

  _createClass(ContextKeyDefinedExpr, [{
    key: "cmp",
    value: function cmp(other) {
      if (other.type !== this.type) {
        return this.type - other.type;
      }

      if (this.key < other.key) {
        return -1;
      }

      if (this.key > other.key) {
        return 1;
      }

      return 0;
    }
  }, {
    key: "equals",
    value: function equals(other) {
      if (other.type === this.type) {
        return this.key === other.key;
      }

      return false;
    }
  }, {
    key: "evaluate",
    value: function evaluate(context) {
      return !!context.getValue(this.key);
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return this.key;
    }
  }, {
    key: "keys",
    value: function keys() {
      return [this.key];
    }
  }, {
    key: "negate",
    value: function negate() {
      return ContextKeyNotExpr.create(this.key);
    }
  }], [{
    key: "create",
    value: function create(key) {
      var staticValue = STATIC_VALUES.get(key);

      if (typeof staticValue === 'boolean') {
        return staticValue ? ContextKeyTrueExpr.INSTANCE : ContextKeyFalseExpr.INSTANCE;
      }

      return new ContextKeyDefinedExpr(key);
    }
  }]);

  return ContextKeyDefinedExpr;
}();
export var ContextKeyEqualsExpr = /*#__PURE__*/function () {
  function ContextKeyEqualsExpr(key, value) {
    _classCallCheck(this, ContextKeyEqualsExpr);

    this.key = key;
    this.value = value;
    this.type = 4
    /* Equals */
    ;
  }

  _createClass(ContextKeyEqualsExpr, [{
    key: "cmp",
    value: function cmp(other) {
      if (other.type !== this.type) {
        return this.type - other.type;
      }

      if (this.key < other.key) {
        return -1;
      }

      if (this.key > other.key) {
        return 1;
      }

      if (this.value < other.value) {
        return -1;
      }

      if (this.value > other.value) {
        return 1;
      }

      return 0;
    }
  }, {
    key: "equals",
    value: function equals(other) {
      if (other.type === this.type) {
        return this.key === other.key && this.value === other.value;
      }

      return false;
    }
  }, {
    key: "evaluate",
    value: function evaluate(context) {
      // Intentional ==
      // eslint-disable-next-line eqeqeq
      return context.getValue(this.key) == this.value;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return this.key + ' == \'' + this.value + '\'';
    }
  }, {
    key: "keys",
    value: function keys() {
      return [this.key];
    }
  }, {
    key: "negate",
    value: function negate() {
      return ContextKeyNotEqualsExpr.create(this.key, this.value);
    }
  }], [{
    key: "create",
    value: function create(key, value) {
      if (typeof value === 'boolean') {
        return value ? ContextKeyDefinedExpr.create(key) : ContextKeyNotExpr.create(key);
      }

      var staticValue = STATIC_VALUES.get(key);

      if (typeof staticValue === 'boolean') {
        var trueValue = staticValue ? 'true' : 'false';
        return value === trueValue ? ContextKeyTrueExpr.INSTANCE : ContextKeyFalseExpr.INSTANCE;
      }

      return new ContextKeyEqualsExpr(key, value);
    }
  }]);

  return ContextKeyEqualsExpr;
}();
export var ContextKeyInExpr = /*#__PURE__*/function () {
  function ContextKeyInExpr(key, valueKey) {
    _classCallCheck(this, ContextKeyInExpr);

    this.key = key;
    this.valueKey = valueKey;
    this.type = 10
    /* In */
    ;
  }

  _createClass(ContextKeyInExpr, [{
    key: "cmp",
    value: function cmp(other) {
      if (other.type !== this.type) {
        return this.type - other.type;
      }

      if (this.key < other.key) {
        return -1;
      }

      if (this.key > other.key) {
        return 1;
      }

      if (this.valueKey < other.valueKey) {
        return -1;
      }

      if (this.valueKey > other.valueKey) {
        return 1;
      }

      return 0;
    }
  }, {
    key: "equals",
    value: function equals(other) {
      if (other.type === this.type) {
        return this.key === other.key && this.valueKey === other.valueKey;
      }

      return false;
    }
  }, {
    key: "evaluate",
    value: function evaluate(context) {
      var source = context.getValue(this.valueKey);
      var item = context.getValue(this.key);

      if (Array.isArray(source)) {
        return source.indexOf(item) >= 0;
      }

      if (typeof item === 'string' && typeof source === 'object' && source !== null) {
        return hasOwnProperty.call(source, item);
      }

      return false;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return this.key + ' in \'' + this.valueKey + '\'';
    }
  }, {
    key: "keys",
    value: function keys() {
      return [this.key, this.valueKey];
    }
  }, {
    key: "negate",
    value: function negate() {
      return ContextKeyNotInExpr.create(this);
    }
  }], [{
    key: "create",
    value: function create(key, valueKey) {
      return new ContextKeyInExpr(key, valueKey);
    }
  }]);

  return ContextKeyInExpr;
}();
export var ContextKeyNotInExpr = /*#__PURE__*/function () {
  function ContextKeyNotInExpr(_actual) {
    _classCallCheck(this, ContextKeyNotInExpr);

    this._actual = _actual;
    this.type = 11
    /* NotIn */
    ; //
  }

  _createClass(ContextKeyNotInExpr, [{
    key: "cmp",
    value: function cmp(other) {
      if (other.type !== this.type) {
        return this.type - other.type;
      }

      return this._actual.cmp(other._actual);
    }
  }, {
    key: "equals",
    value: function equals(other) {
      if (other.type === this.type) {
        return this._actual.equals(other._actual);
      }

      return false;
    }
  }, {
    key: "evaluate",
    value: function evaluate(context) {
      return !this._actual.evaluate(context);
    }
  }, {
    key: "serialize",
    value: function serialize() {
      throw new Error('Method not implemented.');
    }
  }, {
    key: "keys",
    value: function keys() {
      return this._actual.keys();
    }
  }, {
    key: "negate",
    value: function negate() {
      return this._actual;
    }
  }], [{
    key: "create",
    value: function create(actual) {
      return new ContextKeyNotInExpr(actual);
    }
  }]);

  return ContextKeyNotInExpr;
}();
export var ContextKeyNotEqualsExpr = /*#__PURE__*/function () {
  function ContextKeyNotEqualsExpr(key, value) {
    _classCallCheck(this, ContextKeyNotEqualsExpr);

    this.key = key;
    this.value = value;
    this.type = 5
    /* NotEquals */
    ;
  }

  _createClass(ContextKeyNotEqualsExpr, [{
    key: "cmp",
    value: function cmp(other) {
      if (other.type !== this.type) {
        return this.type - other.type;
      }

      if (this.key < other.key) {
        return -1;
      }

      if (this.key > other.key) {
        return 1;
      }

      if (this.value < other.value) {
        return -1;
      }

      if (this.value > other.value) {
        return 1;
      }

      return 0;
    }
  }, {
    key: "equals",
    value: function equals(other) {
      if (other.type === this.type) {
        return this.key === other.key && this.value === other.value;
      }

      return false;
    }
  }, {
    key: "evaluate",
    value: function evaluate(context) {
      // Intentional !=
      // eslint-disable-next-line eqeqeq
      return context.getValue(this.key) != this.value;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return this.key + ' != \'' + this.value + '\'';
    }
  }, {
    key: "keys",
    value: function keys() {
      return [this.key];
    }
  }, {
    key: "negate",
    value: function negate() {
      return ContextKeyEqualsExpr.create(this.key, this.value);
    }
  }], [{
    key: "create",
    value: function create(key, value) {
      if (typeof value === 'boolean') {
        if (value) {
          return ContextKeyNotExpr.create(key);
        }

        return ContextKeyDefinedExpr.create(key);
      }

      var staticValue = STATIC_VALUES.get(key);

      if (typeof staticValue === 'boolean') {
        var falseValue = staticValue ? 'true' : 'false';
        return value === falseValue ? ContextKeyFalseExpr.INSTANCE : ContextKeyTrueExpr.INSTANCE;
      }

      return new ContextKeyNotEqualsExpr(key, value);
    }
  }]);

  return ContextKeyNotEqualsExpr;
}();
export var ContextKeyNotExpr = /*#__PURE__*/function () {
  function ContextKeyNotExpr(key) {
    _classCallCheck(this, ContextKeyNotExpr);

    this.key = key;
    this.type = 3
    /* Not */
    ;
  }

  _createClass(ContextKeyNotExpr, [{
    key: "cmp",
    value: function cmp(other) {
      if (other.type !== this.type) {
        return this.type - other.type;
      }

      if (this.key < other.key) {
        return -1;
      }

      if (this.key > other.key) {
        return 1;
      }

      return 0;
    }
  }, {
    key: "equals",
    value: function equals(other) {
      if (other.type === this.type) {
        return this.key === other.key;
      }

      return false;
    }
  }, {
    key: "evaluate",
    value: function evaluate(context) {
      return !context.getValue(this.key);
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return '!' + this.key;
    }
  }, {
    key: "keys",
    value: function keys() {
      return [this.key];
    }
  }, {
    key: "negate",
    value: function negate() {
      return ContextKeyDefinedExpr.create(this.key);
    }
  }], [{
    key: "create",
    value: function create(key) {
      var staticValue = STATIC_VALUES.get(key);

      if (typeof staticValue === 'boolean') {
        return staticValue ? ContextKeyFalseExpr.INSTANCE : ContextKeyTrueExpr.INSTANCE;
      }

      return new ContextKeyNotExpr(key);
    }
  }]);

  return ContextKeyNotExpr;
}();
export var ContextKeyRegexExpr = /*#__PURE__*/function () {
  function ContextKeyRegexExpr(key, regexp) {
    _classCallCheck(this, ContextKeyRegexExpr);

    this.key = key;
    this.regexp = regexp;
    this.type = 7
    /* Regex */
    ; //
  }

  _createClass(ContextKeyRegexExpr, [{
    key: "cmp",
    value: function cmp(other) {
      if (other.type !== this.type) {
        return this.type - other.type;
      }

      if (this.key < other.key) {
        return -1;
      }

      if (this.key > other.key) {
        return 1;
      }

      var thisSource = this.regexp ? this.regexp.source : '';
      var otherSource = other.regexp ? other.regexp.source : '';

      if (thisSource < otherSource) {
        return -1;
      }

      if (thisSource > otherSource) {
        return 1;
      }

      return 0;
    }
  }, {
    key: "equals",
    value: function equals(other) {
      if (other.type === this.type) {
        var thisSource = this.regexp ? this.regexp.source : '';
        var otherSource = other.regexp ? other.regexp.source : '';
        return this.key === other.key && thisSource === otherSource;
      }

      return false;
    }
  }, {
    key: "evaluate",
    value: function evaluate(context) {
      var value = context.getValue(this.key);
      return this.regexp ? this.regexp.test(value) : false;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      var value = this.regexp ? "/".concat(this.regexp.source, "/").concat(this.regexp.ignoreCase ? 'i' : '') : '/invalid/';
      return "".concat(this.key, " =~ ").concat(value);
    }
  }, {
    key: "keys",
    value: function keys() {
      return [this.key];
    }
  }, {
    key: "negate",
    value: function negate() {
      return ContextKeyNotRegexExpr.create(this);
    }
  }], [{
    key: "create",
    value: function create(key, regexp) {
      return new ContextKeyRegexExpr(key, regexp);
    }
  }]);

  return ContextKeyRegexExpr;
}();
export var ContextKeyNotRegexExpr = /*#__PURE__*/function () {
  function ContextKeyNotRegexExpr(_actual) {
    _classCallCheck(this, ContextKeyNotRegexExpr);

    this._actual = _actual;
    this.type = 8
    /* NotRegex */
    ; //
  }

  _createClass(ContextKeyNotRegexExpr, [{
    key: "cmp",
    value: function cmp(other) {
      if (other.type !== this.type) {
        return this.type - other.type;
      }

      return this._actual.cmp(other._actual);
    }
  }, {
    key: "equals",
    value: function equals(other) {
      if (other.type === this.type) {
        return this._actual.equals(other._actual);
      }

      return false;
    }
  }, {
    key: "evaluate",
    value: function evaluate(context) {
      return !this._actual.evaluate(context);
    }
  }, {
    key: "serialize",
    value: function serialize() {
      throw new Error('Method not implemented.');
    }
  }, {
    key: "keys",
    value: function keys() {
      return this._actual.keys();
    }
  }, {
    key: "negate",
    value: function negate() {
      return this._actual;
    }
  }], [{
    key: "create",
    value: function create(actual) {
      return new ContextKeyNotRegexExpr(actual);
    }
  }]);

  return ContextKeyNotRegexExpr;
}();
export var ContextKeyAndExpr = /*#__PURE__*/function () {
  function ContextKeyAndExpr(expr) {
    _classCallCheck(this, ContextKeyAndExpr);

    this.expr = expr;
    this.type = 6
    /* And */
    ;
  }

  _createClass(ContextKeyAndExpr, [{
    key: "cmp",
    value: function cmp(other) {
      if (other.type !== this.type) {
        return this.type - other.type;
      }

      if (this.expr.length < other.expr.length) {
        return -1;
      }

      if (this.expr.length > other.expr.length) {
        return 1;
      }

      for (var i = 0, len = this.expr.length; i < len; i++) {
        var r = _cmp(this.expr[i], other.expr[i]);

        if (r !== 0) {
          return r;
        }
      }

      return 0;
    }
  }, {
    key: "equals",
    value: function equals(other) {
      if (other.type === this.type) {
        if (this.expr.length !== other.expr.length) {
          return false;
        }

        for (var i = 0, len = this.expr.length; i < len; i++) {
          if (!this.expr[i].equals(other.expr[i])) {
            return false;
          }
        }

        return true;
      }

      return false;
    }
  }, {
    key: "evaluate",
    value: function evaluate(context) {
      for (var i = 0, len = this.expr.length; i < len; i++) {
        if (!this.expr[i].evaluate(context)) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return this.expr.map(function (e) {
        return e.serialize();
      }).join(' && ');
    }
  }, {
    key: "keys",
    value: function keys() {
      var result = [];

      var _iterator = _createForOfIteratorHelper(this.expr),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var expr = _step.value;
          result.push.apply(result, _toConsumableArray(expr.keys()));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return result;
    }
  }, {
    key: "negate",
    value: function negate() {
      var result = [];

      var _iterator2 = _createForOfIteratorHelper(this.expr),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var expr = _step2.value;
          result.push(expr.negate());
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return ContextKeyOrExpr.create(result);
    }
  }], [{
    key: "create",
    value: function create(_expr) {
      return ContextKeyAndExpr._normalizeArr(_expr);
    }
  }, {
    key: "_normalizeArr",
    value: function _normalizeArr(arr) {
      var expr = [];
      var hasTrue = false;

      var _iterator3 = _createForOfIteratorHelper(arr),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var e = _step3.value;

          if (!e) {
            continue;
          }

          if (e.type === 1
          /* True */
          ) {
            // anything && true ==> anything
            hasTrue = true;
            continue;
          }

          if (e.type === 0
          /* False */
          ) {
            // anything && false ==> false
            return ContextKeyFalseExpr.INSTANCE;
          }

          if (e.type === 6
          /* And */
          ) {
            expr.push.apply(expr, _toConsumableArray(e.expr));
            continue;
          }

          expr.push(e);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      if (expr.length === 0 && hasTrue) {
        return ContextKeyTrueExpr.INSTANCE;
      }

      if (expr.length === 0) {
        return undefined;
      }

      if (expr.length === 1) {
        return expr[0];
      }

      expr.sort(_cmp); // We must distribute any OR expression because we don't support parens
      // OR extensions will be at the end (due to sorting rules)

      var _loop = function _loop() {
        var lastElement = expr[expr.length - 1];

        if (lastElement.type !== 9
        /* Or */
        ) {
          return "break";
        } // pop the last element


        expr.pop(); // pop the second to last element

        var secondToLastElement = expr.pop(); // distribute `lastElement` over `secondToLastElement`

        var resultElement = ContextKeyOrExpr.create(lastElement.expr.map(function (el) {
          return ContextKeyAndExpr.create([el, secondToLastElement]);
        }));

        if (resultElement) {
          expr.push(resultElement);
          expr.sort(_cmp);
        }
      };

      while (expr.length > 1) {
        var _ret = _loop();

        if (_ret === "break") break;
      }

      return new ContextKeyAndExpr(expr);
    }
  }]);

  return ContextKeyAndExpr;
}();
export var ContextKeyOrExpr = /*#__PURE__*/function () {
  function ContextKeyOrExpr(expr) {
    _classCallCheck(this, ContextKeyOrExpr);

    this.expr = expr;
    this.type = 9
    /* Or */
    ;
  }

  _createClass(ContextKeyOrExpr, [{
    key: "cmp",
    value: function cmp(other) {
      if (other.type !== this.type) {
        return this.type - other.type;
      }

      if (this.expr.length < other.expr.length) {
        return -1;
      }

      if (this.expr.length > other.expr.length) {
        return 1;
      }

      for (var i = 0, len = this.expr.length; i < len; i++) {
        var r = _cmp(this.expr[i], other.expr[i]);

        if (r !== 0) {
          return r;
        }
      }

      return 0;
    }
  }, {
    key: "equals",
    value: function equals(other) {
      if (other.type === this.type) {
        if (this.expr.length !== other.expr.length) {
          return false;
        }

        for (var i = 0, len = this.expr.length; i < len; i++) {
          if (!this.expr[i].equals(other.expr[i])) {
            return false;
          }
        }

        return true;
      }

      return false;
    }
  }, {
    key: "evaluate",
    value: function evaluate(context) {
      for (var i = 0, len = this.expr.length; i < len; i++) {
        if (this.expr[i].evaluate(context)) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return this.expr.map(function (e) {
        return e.serialize();
      }).join(' || ');
    }
  }, {
    key: "keys",
    value: function keys() {
      var result = [];

      var _iterator4 = _createForOfIteratorHelper(this.expr),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var expr = _step4.value;
          result.push.apply(result, _toConsumableArray(expr.keys()));
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return result;
    }
  }, {
    key: "negate",
    value: function negate() {
      var result = [];

      var _iterator5 = _createForOfIteratorHelper(this.expr),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var expr = _step5.value;
          result.push(expr.negate());
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      var terminals = function terminals(node) {
        if (node.type === 9
        /* Or */
        ) {
          return node.expr;
        }

        return [node];
      }; // We don't support parens, so here we distribute the AND over the OR terminals
      // We always take the first 2 AND pairs and distribute them


      while (result.length > 1) {
        var LEFT = result.shift();
        var RIGHT = result.shift();
        var all = [];

        var _iterator6 = _createForOfIteratorHelper(terminals(LEFT)),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var left = _step6.value;

            var _iterator7 = _createForOfIteratorHelper(terminals(RIGHT)),
                _step7;

            try {
              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                var right = _step7.value;
                all.push(ContextKeyExpr.and(left, right));
              }
            } catch (err) {
              _iterator7.e(err);
            } finally {
              _iterator7.f();
            }
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }

        result.unshift(ContextKeyExpr.or.apply(ContextKeyExpr, all));
      }

      return result[0];
    }
  }], [{
    key: "create",
    value: function create(_expr) {
      var expr = ContextKeyOrExpr._normalizeArr(_expr);

      if (expr.length === 0) {
        return undefined;
      }

      if (expr.length === 1) {
        return expr[0];
      }

      return new ContextKeyOrExpr(expr);
    }
  }, {
    key: "_normalizeArr",
    value: function _normalizeArr(arr) {
      var expr = [];
      var hasFalse = false;

      if (arr) {
        for (var i = 0, len = arr.length; i < len; i++) {
          var e = arr[i];

          if (!e) {
            continue;
          }

          if (e.type === 0
          /* False */
          ) {
            // anything || false ==> anything
            hasFalse = true;
            continue;
          }

          if (e.type === 1
          /* True */
          ) {
            // anything || true ==> true
            return [ContextKeyTrueExpr.INSTANCE];
          }

          if (e.type === 9
          /* Or */
          ) {
            expr = expr.concat(e.expr);
            continue;
          }

          expr.push(e);
        }

        if (expr.length === 0 && hasFalse) {
          return [ContextKeyFalseExpr.INSTANCE];
        }

        expr.sort(_cmp);
      }

      return expr;
    }
  }]);

  return ContextKeyOrExpr;
}();
export var RawContextKey = /*#__PURE__*/function (_ContextKeyDefinedExp) {
  _inherits(RawContextKey, _ContextKeyDefinedExp);

  var _super = _createSuper(RawContextKey);

  function RawContextKey(key, defaultValue) {
    var _this3;

    _classCallCheck(this, RawContextKey);

    _this3 = _super.call(this, key);
    _this3._defaultValue = defaultValue;
    return _this3;
  }

  _createClass(RawContextKey, [{
    key: "bindTo",
    value: function bindTo(target) {
      return target.createKey(this.key, this._defaultValue);
    }
  }, {
    key: "getValue",
    value: function getValue(target) {
      return target.getContextKeyValue(this.key);
    }
  }, {
    key: "toNegated",
    value: function toNegated() {
      return ContextKeyExpr.not(this.key);
    }
  }]);

  return RawContextKey;
}(ContextKeyDefinedExpr);
export var IContextKeyService = createDecorator('contextKeyService');
export var SET_CONTEXT_COMMAND_ID = 'setContext';